import { render, staticRenderFns } from "./ContainerComponent.vue?vue&type=template&id=0fed8106&lang=pug"
import script from "./ContainerComponent.vue?vue&type=script&lang=js"
export * from "./ContainerComponent.vue?vue&type=script&lang=js"
import style0 from "./ContainerComponent.vue?vue&type=style&index=0&id=0fed8106&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports